import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import About from "../components/About";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(About);
const withTranslationComponent = withTranslation(["about", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/About.js